import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './licitaciones.css';
 
const Licitaciones = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container licitaciones-container'>
        <div className='row'>
            <div className='col-12'>
                <div className='licitaciones_title'>
                    <h1>Licitaciones Públicas Nacionales</h1>
                </div>
            </div>
        </div>

        <div className='row'>
        <div class="accordion-item">
              <h2 class="accordion-header" id="headingOneCECULTAH-LA-01-2026"><button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOneCECULTAH-LA-01-2026" aria-expanded="false" aria-controls="collapseOneCECULTAH-LA-01-2026">CECULTAH-LA-01-2026 | Suministro e instalación de cerraduras para puertas, reparación de línea hidráulica y cambio de rieles de puerta de madera en diversos espacios a cargo de Consejo Estatal para la Cultura y las artes de Hidalgo (Centro de las Artes, Teatro Hidalgo Bartolomé de Medina y Teatro Guillermo Romo de Vivar).</button></h2>
              <div id="collapseOneCECULTAH-LA-01-2026" class="accordion-collapse collapse" aria-labelledby="headingOneCECULTAH-LA-01-2026" data-bs-parent="#accordionExample">
                 <div class="accordion-body">
                    <ul class="list-group">
                        <li class="list-group-item">Convocatoria<a class="card_trimestre bg-secondary" href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/procedimientos/CECULTAH-LA-01-2026/CECULTAH-LA-01-2026 Convocatoria.pdf" target="_blank" rel="noopener noreferrer"><i class="badge bg-secondary">.pdf</i></a></li>
                        <li class="list-group-item">Bases<a class="card_trimestre bg-secondary" href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/procedimientos/CECULTAH-LA-01-2026/CECULTAH-LA-01-2026 Bases.pdf" target="_blank" rel="noopener noreferrer"><i class="badge bg-secondary">.pdf</i></a></li>
                        <li class="list-group-item">Junta de Aclaraciones<a class="card_trimestre bg-secondary" href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/procedimientos/CECULTAH-LA-01-2026/CECULTAH-LA-01-2026 Junta de aclaraciones.pdf" target="_blank" rel="noopener noreferrer"><i class="badge bg-secondary">.pdf</i></a></li>
                        {/*<li class="list-group-item">Apertura de Propuestas<a class="card_trimestre bg-secondary" href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/procedimientos/CECULTAH-LA-01-2026/" target="_blank" rel="noopener noreferrer"><i class="badge bg-secondary">.pdf</i></a></li>*/}
                        {/*<li class="list-group-item">Fallo<a class="card_trimestre bg-secondary" href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/procedimientos/CECULTAH-LA-01-2026/" target="_blank" rel="noopener noreferrer"><i class="badge bg-secondary">.pdf</i></a></li>*/}
                   </ul>
                 </div>
              </div>
           </div> 

           


        
    
        </div>
    </div>
  )
}

export default Licitaciones